"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UPDATE_APPLIED_VALUE_COUPONS = 'UPDATE_APPLIED_VALUE_COUPONS';
const UPDATE_CART_PRICE_DISCOUNTS = 'UPDATE_CART_PRICE_DISCOUNTS';
const UPDATE_VALUE_DISCOUNTED_PRODUCTS = 'UPDATE_VALUE_DISCOUNTED_PRODUCTS';
exports.default = {
    UPDATE_APPLIED_VALUE_COUPONS,
    UPDATE_CART_PRICE_DISCOUNTS,
    UPDATE_VALUE_DISCOUNTED_PRODUCTS
};
//# sourceMappingURL=types.js.map